export const getLayers = (
  hoverId,
  inactiveOpacity = 0.5,
  activeOpacity = 1.0
) => [
  {
    id: 'geofences',
    type: 'fill',
    source: 'geofences',
    paint: {
      'fill-color': ['get', 'color'],
      'fill-opacity': inactiveOpacity,
    },
  },
  {
    id: 'geofences-hover',
    type: 'fill',
    source: 'geofences',
    paint: {
      'fill-color': ['get', 'color'],
      'fill-opacity': activeOpacity,
    },
    filter: ['==', 'key', hoverId],
  },
];

export const getSource = geofences => ({
  type: 'FeatureCollection',
  features: geofences
    ? geofences.map(geofence => ({
        type: 'Feature',
        properties: {
          id: geofence.id,
          key: geofence.key,
          color: geofence.color,
        },
        geometry: geofence.geometry,
      }))
    : [],
});

export const getGeojson = coordinates => ({
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'Polygon',
        coordinates,
      },
    },
  ],
});
